import { setToDateMonthYearInWords } from "../../../helpers";

const AverageSpendChartLogic = () => {
  const xAxisFormatter = (tick) => {
    return setToDateMonthYearInWords(tick);
  };

  return {
    xAxisFormatter,
  };
};

export default AverageSpendChartLogic;
